<template>
  <b-navbar
    v-show="!hideNavbar"
    toggleable="lg"
    :sticky="sticky"
    id="nav"
    type="dark"
  >
    <div class="logo">
      <img src="../assets/LogoZecon.png" alt="" />
    </div>

    <div class="menu-list">
      <b-navbar-toggle
        target="nav-collapse"
        @click="toggleCollapse"
        v-b-toggle.nav-collapse
      ></b-navbar-toggle>

      <b-collapse
        id="nav-collapse"
        is-nav
        :class="{ 'custom-open': isCollapseOpen }"
      >
        <b-navbar-nav>
          <b-nav-item
            class="ml-4 mt-2 cursor-pointer"
            href="/"
            :class="{ 'ul-open': isCollapseOpen }"
          >
            <a
              style="
                font-size: 1.4em;
                color: white;
                text-decoration: none;
                cursor: pointer;
              "
            >
              Home
            </a>
          </b-nav-item>
          <b-nav-item class="ml-4 mt-2 cursor-pointer" href="/#servicos">
            <a
              style="font-size: 1.4em; color: white; text-decoration: none"
              :class="{ 'ul-open': isCollapseOpen }"
            >
              Portfólio
            </a>
          </b-nav-item>
          <b-nav-item class="ml-4" href="/#divisoes">
            <b-nav-item-dropdown text="Divisões" right style="font-size: 1.4em">
              <template #button-content>
                <a
                  style="font-size: 1em; color: white; text-decoration: none"
                  :class="{ 'ul-open': isCollapseOpen }"
                >
                  Divisões
                </a>
              </template>
              <b-dropdown-item href="/#divisoes">Divisões</b-dropdown-item>
              <b-dropdown-item href="/Bombas">Bombas</b-dropdown-item>
              <b-dropdown-item href="/Valvulas">Válvulas</b-dropdown-item>
            </b-nav-item-dropdown>
          </b-nav-item>
          <b-nav-item class="ml-4 mt-2 cursor-pointer" href="/#acao-social">
            <a
              style="font-size: 1.4em; color: white; text-decoration: none"
              :class="{ 'ul-open': isCollapseOpen }"
            >
              Ação Social
            </a>
          </b-nav-item>
          <b-nav-item class="ml-4 mt-2 cursor-pointer" href="/#contato">
            <a
              style="font-size: 1.4em; color: white; text-decoration: none"
              :class="{ 'ul-open': isCollapseOpen }"
            >
              Contato
            </a>
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </div>
  </b-navbar>
</template>

<script>
export default {
  name: "Navbar",
  data() {
    return {
      sticky: true,
      isCollapseOpen: false,
      hideNavbar: false,
    };
  },
  methods: {
    toggleCollapse() {
      this.isCollapseOpen = !this.isCollapseOpen;
    },
    hideNavbarOnNavigate() {
      setTimeout(() => {
        this.hideNavbar = true;
      }, 30);
    },
    handleScroll() {
      if (this.hideNavbar) {
        this.hideNavbar = false;
      }
    },
  },
  mounted() {
    // Adicione um listener para quando a navegação ocorrer
    this.$router.beforeEach((to, from, next) => {
      this.hideNavbarOnNavigate();
      next();
    });
    // Adicione um ouvinte de evento global para movimento do mouse
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    // Remova o ouvinte de evento quando o componente for destruído
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style scoped>
#nav {
  display: flex;
  align-items: center;
  justify-content: space-around;
  background-color: #343333cc;
  opacity: 0.9;
  padding: 0;
}

.logo {
  margin: 2vh 0 2vh 6.6vw;
  display: flex;
}

.logo img {
  height: 7vh;
}

.menu-list {
  margin: 0 6.6vw 0 0;
}

.flex-container {
  display: flex;
  justify-content: center;
}

@media screen and (max-width: 1280px) {
  .menu-list a {
    font-size: 0.8em;
  }

  .logo img {
    height: 6vh;
  }
}

@media screen and (max-width: 624px) {
  #nav {
    max-width: 100%;
  }

  .logo {
    margin: 2vh 0 2vh 6vw;
  }

  .menu-list {
    margin: 0 6vw 0 0;
    flex-direction: column;
  }
}
</style>